import { SortBy } from './search-models';

export interface EmployeeChangeLogItem {
	event_id: string | number,
	client_nbr: string,
	guid: string,
	first_name: string,
	last_name: string,
	event_code: string,
	event_type: string,
	submitted_by: string,
	submitted_date: string,
	effective_date: string,
	completed_by: string,
	sr_number: string,
	transaction_status: string,
	impacted_products: string,
	employer: string,
}

export interface ApiPagination {
	currentPage: string,
	pageSize: number,
	totalRecordsCount: number,
	totalPages: number
}

export enum DateType {
	SUBMITTED = 'submitted_date',
	EFFECTIVE = 'effective_date',
}

export interface DateRange {
	from_date: string,
	to_date: string,
}

export interface ApiFilters {
	date_type?: DateType,
	date_range?: DateRange,
	entities?: string[],
	event_type?: string[],
	submitted_by?: string[],
}

export interface PersonEntity  {
	client_nbr: string,
	guid: string,
	first_name: string,
	last_name: string,
}

export interface ApiEventType {
	id: number,
	desc: string,
}

export interface DistinctFilter{
	entities: PersonEntity[],
	submitted_by: string[],
	event_type: ApiEventType[],
}

export interface EmployeeChangeLogApiResponse {
	pagination: ApiPagination,
	filter_by: ApiFilters,
	eventLogs: EmployeeChangeLogItem[],
	distinct_filter: DistinctFilter,
}

export interface EmployeeChangeLogApiFilter {
	date_type?: DateType,
	date_range?: DateRange,
	entities?: string[],
	event_type?: string[],
	submitted_by?: string[],
}


export interface ApiSortBy {
	field: string,
	order_by: SortBy,
}

export interface EmployeeChangeLogPayload {
	page: string,
	limit: string,
	filter_by?: EmployeeChangeLogApiFilter,
	sort_by?: ApiSortBy,
}